<script>
  import { createEventDispatcher } from "svelte";

  import Item from "./item.svelte";

  export let layouts;
  export let items;
  export let selected = [];

  let w;
  let width;

  $: w, setWidth();

  const setWidth = () => {
    if (w) width = w;
  }

  const checkType = (value, expr) => new Function('value', expr)(value);

  const getLayout = json => {
    for (const [type, expr] of Object.entries(layouts.types)) {
      if (checkType(json, expr)) {
        return type;
      }
    }
  }

  const message = detail => {
    if (detail.type === 'clicked') {
      if (selected.includes(detail.idx)) {
        selected.splice(selected.indexOf(detail.idx), 1);
        selected = selected;
        dispatch('deselect', detail.idx);
      } else {
        selected.push(detail.idx);
        selected = selected;
        dispatch('select', detail.idx);
      }
    } else {
      dispatch('message', detail);
    }
  }

  const dispatch = createEventDispatcher();
</script>

<div class:lt-gallery={ true } class={ $$props.class } bind:offsetWidth={ w } style={ width ? `width: ${ width }px;` : undefined }>
  {#each items as item, i}
    {@const layout = getLayout(item)}
    <Item class="lt-item" layout={ layouts.cards[layout] } values={ item } selected={ selected.includes(i) } on:message={ ({ detail }) => { message({ ...detail, idx: i }) } } />
  {/each}
</div>